//import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CityService } from '../../services/city.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/observable/of';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { timeInterval } from "rxjs/operators/timeInterval";
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap'
import { debounce } from "rxjs/operator/debounce";
import { FilterPipe } from '../../services/FilterPipe';
import { SafePipe } from '../../services/SafePipe';
import { MapComponent } from '../map/map.component'
import { Pipe, PipeTransform, Component, NgModule, OnInit, AfterViewInit } from '@angular/core'
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
import { summaryFileName } from '@angular/compiler/src/aot/util';
import * as Chart from 'chart.js'
import { FormBuilder, FormGroup } from '@angular/forms';
declare var google: any;
import { NgProgress } from 'ngx-progressbar';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsComponent } from "../contactus/contactus.component";
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../../environments/environment';

@Component({
  selector: "main-app",
  templateUrl: './main.component.html',
  styleUrls: ["./main.component.scss"],
  providers: [FilterPipe, SafePipe],
})

export class MainComponent implements OnInit, AfterViewInit {


  ChangeDistrict(district: string) {
    this.selectedDistrict = district;
  }
  canvas: any;
  form;
  ctx: any;
  doughnutChart: any;
  public mapOrTable: string = 'map';
  filteredCities: any;
  public title: string = 'DigiLocaly';
  lat: number = 32.794046;
  lng: number = 34.989571;
  zoom: number = 10;
  selectedLocalGovernment: any = [];
  //selectedDistrict: any;
  selectedSocioEconomicCluster: any = [];
  //selectedDistrict :any = { value: 'המרכז', viewValue: 'מחוז המרכז ות"א' };
  selectedDistrict :any = { value: 'כלל המחוזות', viewValue: 'כלל המחוזות' };

  selectedTab: any = 0;
  colorArray: any = [];
  youtubeUrl = 'https://www.youtube.com/embed/eOq6qJzfPWs?showinfo=0';
  localGovernments = this.cityService.localGovernments;
  avg: number = 0;
  districts = Array.from(this.cityService.districts);
  socioEconomicTitle = 'בחירת אשכול חברתי-כלכלי';
  localGovernmentTitle = 'בחירת סוג רשות';
  indexs = this.cityService.indexs;

  //public cities: Array<any>;

   initDoughnutChart() {

    // destroy old chart
    //this.barChart.chart && this.barChart.chart.destroy();

    this.canvas = document.getElementById('doughnutChart');
    this.ctx = this.canvas.getContext('2d');
    //console.log(this.ctx);

    //this.setChartData();

    this.doughnutChart = new Chart(this.ctx, {
      //labels:this.doughnutChartLabels,
      type: 'doughnut',
      data: this.doughnutChartData,
      options: this.doughnutChartOptions
    });

  }
  public constructor(public cityService: CityService, private http: Http,
    private filterPipe: FilterPipe, private sanitizer: DomSanitizer,
    private safePipe: SafePipe, private formBuilder: FormBuilder, public ngProgress: NgProgress, private modalService: NgbModal,private deviceService: DeviceDetectorService) {
      if(this.deviceService.isMobile()){
        window.location.href= environment.Mobile;
      }
  }

  trustSrcUrl = function (data) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(data);
  }

  // Doughnut
  doughnutChartLabels: string[] = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  doughnutDatasets = [
    {
      //label: "TeamA Score",
      data: [],
      backgroundColor: [

      ],
      borderColor: [

      ],
      //borderWidth: [1, 1, 1, 1, 1]
    }
  ]

  doughnutChartData = {
    labels: [],
    datasets: this.doughnutDatasets
  }
  //number[] = [350, 450, 100];
  doughnutChartOptions = {
    tooltips: {
      enabled: true,
      fontFamily: "Open Sans Hebrew",
    },
    //rotation: -Math.PI,
    //cutoutPercentage: 30,
    //circumference: Math.PI,
    legend: {
      display: false
    },
    animation: {
      animateRotate: false,
      animateScale: true
    },
    responsive: true,
    cutoutPercentage: 80
  };


  // events
  public chartClicked(e: any): void {
    //console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }



  // getCities(data: any) {

  //   alert('getCities');
  //   this.cities = data;
  //   this.initMarkers(this.selectedTab);
  // }

  openContactUs() {
    let dialogRef = this.modalService.open(ContactUsComponent, { backdrop: 'static', size: 'lg' });
    
  }

  setPieChartRow() {
    let pieArr: any[];
//debugger
    if (this.selectedTab == 0) {
      pieArr = this.filteredCities.map(function (item) {
        return item.TotalValue;
      });
    }
    if (this.selectedTab == 1) {
      pieArr = this.filteredCities.map(function (item) {
        return item.ResidentTotal;
      });
    }

    if (this.selectedTab == 3) {
      pieArr = this.filteredCities.map(function (item) {
        return item.SiteAccessibilityTotal;
      });
    }
    if (this.selectedTab == 2) {
      pieArr = this.filteredCities.map(function (item) {
        return item.LocalBusinessTotal;
      });
    }
    if (this.selectedTab == 4) {
      pieArr = this.filteredCities.map(function (item) {
        return item.EngineeringTotal;
      });
    }

    

    var total = pieArr.reduce(function (prev, curr) {
      return prev + curr;
    });


    this.avg = Math.round(total / this.filteredCities.length);

    this.updateDoughnutChart();


  }

  getHeaderText() {
    let title = ''


    if (this.selectedDistrict) {
      title = 'מחוז: ' + this.selectedDistrict.viewValue;
    }

    if (this.selectedLocalGovernment != '') {
      title += ' | ' + 'רשות: ' + this.selectedLocalGovernment;
    }

    if (this.selectedSocioEconomicCluster != '') {
      title += ' | אשכול: ' + this.selectedSocioEconomicCluster;
    }

    return title;
  }

  updateDoughnutChart(): any {

    let ecoArr = [{ name: 'אשכול 1', val: 0 }, { name: 'אשכול 2', val: 0 }, { name: 'אשכול 3', val: 0 }, { name: 'אשכול 4', val: 0 }
      , { name: 'אשכול 5', val: 0 }, { name: 'אשכול 6', val: 0 }, { name: 'אשכול 7', val: 0 }, { name: 'אשכול 8', val: 0 }
      , { name: 'אשכול 9', val: 0 }, { name: 'אשכול 10', val: 0 }]

    for (let i = 0; i < this.filteredCities.length; i++) {

      let result = 0;
      if (this.selectedTab == 0) {
        result = this.filteredCities[i].TotalValue;
      }
      if (this.selectedTab == 1) {
        result = this.filteredCities[i].ResidentTotal;
      }

      if (this.selectedTab == 3) {
        result = this.filteredCities[i].SiteAccessibilityTotal;
      }
      if (this.selectedTab == 2) {
        result = this.filteredCities[i].LocalBusinessTotal;
      }
      if (this.selectedTab == 4) {
        result = this.filteredCities[i].EngineeringTotal;
      }
      let index = this.cityService.getColorPlace(result);
      ecoArr[index].val += 1;
    }

    this.doughnutChartData.labels = [];
    this.doughnutChartData.datasets[0].data = [];
    this.doughnutChartData.datasets[0].backgroundColor = [];

    for (let i = 0; i < ecoArr.length; i++) {
      if (ecoArr[i].val > 0) {
        this.doughnutChartData.labels.push(ecoArr[i].name)
        this.doughnutChartData.datasets[0].data.push(ecoArr[i].val);
        this.doughnutChartData.datasets[0].backgroundColor.push(this.cityService.colorArray[i]);
      }
    }
    this.doughnutChart.chart.chart.update();

  }
  getBackgroundStyles(place: number) {

    let num = Number(place);
    //console.log(num)
    return '' + this.colorArray[num] + '';
  }


  setArry() {
    this.colorArray = this.cityService.colorArray.slice(0, this.cityService.colorArray.length);
    this.colorArray.reverse();
    this.districts.unshift({ viewValue: 'כלל המחוזות', value: 'כלל המחוזות' });
  }

  public ngOnInit(): void {
    this.ngProgress.start();
    this.initDoughnutChart();
    // debugger;
    // this.cities = this.cityService.cities;
    // this.initMarkers(0);
    // this.setPieChartRow(); 
    // this.setArry(); 
    // this.ngProgress.done();
    this.cityService.getAllCities()
      .subscribe(data => { this.cityService.cities = data, this.initMarkers(0); this.setPieChartRow(); this.setArry(); this.ngProgress.done(); });
  }
  model = {
    left: true,
    middle: false,
    right: false
  };

   fieldSorter = (fields) => (a, b) => fields.map(o => {
    let dir = 1;
    if (o[0] === '-') { dir = -1; o=o.substring(1); }
    return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
}).reduce((p, n) => p ? p : n, 0);


  public GetSortOrder(prop: any) {
    return function (a: any, b: any) {
      if (a[prop] < b[prop]) {
        return 1;
      } else if (a[prop] > b[prop]) {
        return -1;
      }
      return 0;
    }
  }

  getLocalGovernmentTitle() {
    //console.log(this.selectedLocalGovernment)

    if (this.selectedLocalGovernment.length == 0)
      this.localGovernmentTitle = 'בחירת סוג רשות';

    else {

      this.localGovernmentTitle = this.selectedLocalGovernment.toString();
    }

    return this.localGovernmentTitle;
  }

  getSocioEconomicTitle() {

    if (this.selectedSocioEconomicCluster.length == 0)
      this.socioEconomicTitle = 'בחירת אשכול חברתי-כלכלי';

    else {

      this.socioEconomicTitle = ' אשכול ' + this.selectedSocioEconomicCluster.toString();
    }

    return this.socioEconomicTitle;
  }


  updateSocioEconomicCluster(event) {

    if (event.target.checked) {
      if (this.selectedSocioEconomicCluster.indexOf(event.target.defaultValue) < 0) {
        this.selectedSocioEconomicCluster.push(event.target.defaultValue);

      }
    } else {
      if (this.selectedSocioEconomicCluster.indexOf(event.target.defaultValue) > -1) {
        this.selectedSocioEconomicCluster.splice(this.selectedSocioEconomicCluster.indexOf(event.target.defaultValue), 1);
      }
    }
    this.setMap();
  }

  clearEconomicClusterCheckbox() {
    //alert('clear');
    for (let _i = 0; _i < 10; _i++) {
      //this.indexs[_i].checked = false;
      (<HTMLInputElement>document.getElementById('checkboxIndex-' + _i)).checked = false;
      this.indexs[_i].enable = false;
    }
    this.selectedSocioEconomicCluster = [];
    //console.log(this.indexs);
  }

  updateLocalGovernment(event) {
    //console.log(event);
    if (event.target.checked) {
      if (this.selectedLocalGovernment.indexOf(event.target.defaultValue) < 0) {
        this.selectedLocalGovernment.push(event.target.defaultValue);

      }
    } else {
      if (this.selectedLocalGovernment.indexOf(event.target.defaultValue) > -1) {
        this.selectedLocalGovernment.splice(this.selectedLocalGovernment.indexOf(event.target.defaultValue), 1);
      }
    }
    this.clearEconomicClusterCheckbox();
    this.setMap();
  }

  updateDistrict(district) {

    this.selectedDistrict = district;
    this.clearEconomicClusterCheckbox();
    this.setMap();
  }

  resetIndexsArray() {
    for (let _i = 0; _i < this.cityService.indexs.length; _i++) {
      this.cityService.indexs[_i].enable = false;
    }
  }





  filter() {


    //debugger;
    this.filteredCities = [];

    if (this.selectedDistrict.value == 'כלל המחוזות') {
      //this.filteredCities = this.cities;
    }

    let filters = {
      //District: [this.selectedDistrict],
      //LocalGovernment:this.selectedLocalGovernment
    };

    if (this.selectedDistrict.value != 'כלל המחוזות') {
      filters['District'] = this.selectedDistrict.value;
    }
    //else{
    //  filters['District'] = '';
    //}

    if (this.selectedLocalGovernment.length > 0) {
      filters['LocalGovernment'] = this.selectedLocalGovernment;
    }
    //this.clearEconomicClusterCheckbox();
    //debugger;
    let filteredCitiesByLocalAndDiscrit = this.cityService.multiFilter(this.cityService.cities, filters);

    for (let _i = 0; _i < filteredCitiesByLocalAndDiscrit.length; _i++) {

      //if (filteredCitiesByLocalAndDiscrit[_i].District == this.selectedDistrict.value || this.selectedDistrict.value == 'הכל') {
      let SocioEconomicCluster = filteredCitiesByLocalAndDiscrit[_i].SocioEconomicCluster;
      this.cityService.indexs[SocioEconomicCluster - 1].enable = true;

      // }
    }


    if (this.selectedSocioEconomicCluster.length > 0) {


     // debugger;
      filters['SocioEconomicCluster'] = [];
      for (var _i = 0; _i < this.selectedSocioEconomicCluster.length; _i++) {

        let num = Number(this.selectedSocioEconomicCluster[_i]);

        filters['SocioEconomicCluster'].push(num);
      }

    }


    // filter the products array by color: blue and black
    // and also by size: 70 and 50
    this.filteredCities = this.cityService.multiFilter(this.cityService.cities, filters);

    //console.log('filteredCities', this.filteredCities);

    /*for (let _i = 0; _i < this.cities.length; _i++) {

      if (this.cities[_i].District == this.selectedDistrict) {
        let SocioEconomicCluster = this.cities[_i].SocioEconomicCluster;
        this.cityService.indexs[SocioEconomicCluster - 1].enable = true;

      }
    }*/

    //console.log(this.cityService.indexs);
  }

  initMarkers(tabIndex: number) {

    //var infoWindow = new google.maps.InfoWindow();
    //console.log(this.selectedDistrict );
   // debugger
    //if (this.selectedDistrict != undefined) {
    //}
    //else {
      if(this.selectedDistrict == undefined)  
          this.selectedDistrict = { value: 'המרכז', viewValue: 'מחוז המרכז ות"א' };

    //}

    this.filter();


    //console.log(this.filteredCities);

    if (tabIndex === 0) {
      this.filteredCities.sort(this.fieldSorter(['Sort', '-TotalValue', '-ResidentTotal', '-LocalBusinessTotal','-SiteAccessibilityTotal','Name']));
      //this.filteredCities.sort(this.GetSortOrder('TotalValue'));
      this.setSelectedValues('TotalValue');
    }
    if (tabIndex === 1) {
      this.filteredCities.sort(this.fieldSorter(['Sort', '-ResidentTotal', '-TotalValue', '-ResidentTotal', '-LocalBusinessTotal','-SiteAccessibilityTotal','Name']));
      //this.filteredCities.sort(this.GetSortOrder('ResidentTotal'));
      this.setSelectedValues('ResidentTotal');
    }
    if (tabIndex === 2) {
      this.filteredCities.sort(this.fieldSorter(['Sort', '-LocalBusinessTotal', '-TotalValue', '-ResidentTotal', '-LocalBusinessTotal','-SiteAccessibilityTotal','Name']));
      //this.filteredCities.sort(this.GetSortOrder('LocalBusinessTotal'));
      this.setSelectedValues('LocalBusinessTotal');
    }
    if (tabIndex === 3) {
      this.filteredCities.sort(this.fieldSorter(['Sort', '-SiteAccessibilityTotal', '-TotalValue', '-ResidentTotal', '-LocalBusinessTotal','-SiteAccessibilityTotal','Name']));
      //this.filteredCities.sort(this.GetSortOrder('SiteAccessibilityTotal'));
      this.setSelectedValues('SiteAccessibilityTotal');
    }

    if (tabIndex === 4) {
      this.filteredCities.sort(this.fieldSorter(['Sort', '-EngineeringTotal', '-TotalValue', '-EngineeringTotal', '-EngineeringTotal','-EngineeringTotal','Name']));
      //this.filteredCities.sort(this.GetSortOrder('SiteAccessibilityTotal'));
      this.setSelectedValues('EngineeringTotal');
    }

    this.setPieChartRow();
  }


setSortPlace (index:number ){

  this.filteredCities[index].sortPlace = index + 1;
        if (index > 0) {
          if (this.filteredCities[index].place == this.filteredCities[index - 1].place) {
            this.filteredCities[index].sortPlace = '-';
          }
          else {
          this.filteredCities[index].sortPlace = index + 1;
          }
        }
       }


  setSelectedValues(category: any) {


    for (let _index = 0; _index < this.filteredCities.length; _index++) {

      if (category == 'TotalValue') {
        this.filteredCities[_index].value = this.filteredCities[_index].TotalValue.toString();
        this.filteredCities[_index].paramNumber = this.filteredCities[_index].TotalValueParamNumber.toString();
        this.filteredCities[_index].paramTotal = this.filteredCities[_index].TotalValueParamTotal;
        this.filteredCities[_index].place = this.filteredCities[_index].TotalValuePlace;
        this.filteredCities[_index].colorPlace = Number((this.cityService.getColorPlace(this.filteredCities[_index].TotalValue)));
        this.filteredCities[_index].title = 'בדירוג הכללי';
      }

      if (category == 'ResidentTotal') {
        this.filteredCities.value = this.filteredCities[_index].ResidentTotal.toString();
        this.filteredCities[_index].paramNumber = this.filteredCities[_index].ResidentTotalParamNumber.toString();
        this.filteredCities[_index].paramTotal = this.filteredCities[_index].ResidentTotalParamTotal;
        this.filteredCities[_index].place = this.filteredCities[_index].ResidentTotalPlace;
        this.filteredCities[_index].colorPlace = Number((this.cityService.getColorPlace(this.filteredCities[_index].ResidentTotal)));
        this.filteredCities[_index].title = 'בדירוג שירותים לתושב';
      }

      if (category == 'LocalBusinessTotal') {
        this.filteredCities.value = this.filteredCities[_index].LocalBusinessTotal.toString();
        this.filteredCities[_index].paramNumber = this.filteredCities[_index].LocalBusinessTotalParamNumber.toString();
        this.filteredCities[_index].paramTotal = this.filteredCities[_index].LocalBusinessTotalParamTotal;
        this.filteredCities[_index].place = this.filteredCities[_index].LocalBusinessTotalPlace;
        this.filteredCities[_index].colorPlace = Number((this.cityService.getColorPlace(this.filteredCities[_index].LocalBusinessTotal)));
        this.filteredCities[_index].title = 'בדירוג שירותים לעסק';
      }

      if (category == 'SiteAccessibilityTotal') {
        this.filteredCities.value = this.filteredCities[_index].SiteAccessibilityTotal.toString();
        this.filteredCities[_index].paramNumber = this.filteredCities[_index].SiteAccessibilityTotalParamNumber.toString();
        this.filteredCities[_index].paramTotal = this.filteredCities[_index].SiteAccessibilityTotalParamTotal;
        this.filteredCities[_index].place = this.filteredCities[_index].SiteAccessibilityTotalPlace;
        this.filteredCities[_index].colorPlace = Number((this.cityService.getColorPlace(this.filteredCities[_index].SiteAccessibilityTotal)));
        this.filteredCities[_index].title = 'בדירוג נגישות';
      }

      if (category == 'EngineeringTotal') {
        this.filteredCities.value = this.filteredCities[_index].EngineeringTotal.toString();
        this.filteredCities[_index].paramNumber = this.filteredCities[_index].EngineeringTotalParamNumber.toString();
        this.filteredCities[_index].paramTotal = this.filteredCities[_index].EngineeringTotalParamTotal;
        this.filteredCities[_index].place = this.filteredCities[_index].EngineeringTotalPlace;
        this.filteredCities[_index].colorPlace = Number((this.cityService.getColorPlace(this.filteredCities[_index].EngineeringTotal)));
        this.filteredCities[_index].title = 'בדירוג שירותי תכנון ובנייה';
      }
      this.setSortPlace(_index);
    }

  }

  ngAfterViewInit() {
    //console.log('afterViewInit => ', this.tabGroup.selectedIndex);
  }

  public revealVideo(div: any) {
    //debugger

    //var video= document.getElementById(video_id).attributes["src"];

    //console.log(video);
    //document.getElementById(video_id).attributes["src"] =video.value + "&autoplay=1"; // adding autoplay to the URL
    //console.log(video);
    this.youtubeUrl += "&autoplay=1";
    document.getElementById(div).style.display = 'block';
  }

  // Hiding the lightbox and removing YouTube autoplay
  hideVideo(div, video_id) {
    //debugger
    //var video = (<HTMLImageElement>document.querySelector(video_id)).src;

    var cleaned = this.youtubeUrl.replace('&autoplay=1', '&autoplay=0'); // removing autoplay form url
    (<HTMLIFrameElement>document.getElementById(video_id)).src  = cleaned;
    document.getElementById(div).style.display = 'none';
  }

  setMap() {

    this.initMarkers(this.selectedTab);
    event.preventDefault();
    this.setPieChartRow()

  }

  change(val) {
    //debugger;
    this.mapOrTable = val;
    this.initMarkers(this.selectedTab);
  }
  onTabChange = (value: number): void => {
    //debugger
    //console.log('tabChangeEvent => ', value);
    //console.log('index => ', tabChangeEvent.activeId.index);
    this.selectedTab = value;
    this.initMarkers(this.selectedTab);
    this.setPieChartRow();
  }

  onIndexChange(event) {

  }

}



// WEBPACK FOOTER //
// ./src/app/component/main/main.component.ts